// Shared public event config
export const HALLOWEEN = {
  slug: "halloween-rave-24",
  title: "Halloween Rave",
  dateLabel: "Friday 24th October",
  timeLabel: "7–10pm",
  dj: "DJ Ewan Hawley",
  price: "£1",
  priceValue: 1,
  maxTickets: 4,
  perk: "Includes your first drink free",
  tagline: "Strictly no alcohol · Members only.",
  capacity: 75,
};

export const EVENTS = {
  [HALLOWEEN.slug]: HALLOWEEN,
};
